import React, { useContext } from 'react'
import { VerifyEmailImg } from '../../helper/imagepath'
import { useDispatch } from 'react-redux'
import { SpinnerContext } from '../../context/spinnerContext'
import { resendVerificationEmail } from '../../redux/slices/authSlice'
import { errorToast, successToast } from '../../util/Toast/toast'
// import { useNavigate } from 'react-router-dom'

const VerifyEmail = ({ verificationEmail, toggleVerifyEmailModal }) => {
  const dispatch = useDispatch()
  // const navigate = useNavigate()
  const { changeLoader } = useContext(SpinnerContext)

  const handleResendVerifyEmail = () => {
    if (verificationEmail) {
      changeLoader(true)
      dispatch(resendVerificationEmail(verificationEmail)).then(({ payload }) => {
        if (payload?.status === 200) {
          toggleVerifyEmailModal()
          successToast(payload?.data?.status_message || 'Register successfully')
          changeLoader(false)
          // navigate('/')
        } else {
          errorToast(payload?.data?.status_message || 'Something went wrong')
          changeLoader(false)
        }
      })
    }
  }
  return (
    <div>
      <img
        className="img-fluid logo-dark mb-3 mt-3"
        src={VerifyEmailImg}
        onError={(event) => {
          event.target.src = VerifyEmailImg
        }}
        alt="Logo"
      />
      <div className="text-center px-5">
        <div className="auth-page-title text-center mb-3">Verify Your Email Address</div>
        <p className="auth-page-sub-title text-center mb-3">
          A verification email has been sent to your email {verificationEmail} please check your email and click the link provide in the email to
          complete your account registration.
        </p>
        <p className="auth-page-sub-title text-center mb-3">
          If you do not receive the email within the next 5 minutes, use the button below to resend verification email.
        </p>
        <button className="btn btn-lg btn-block w-50 btn-primary mb-3" type="button" onClick={handleResendVerifyEmail}>
          Resend Verification Email
        </button>
      </div>
    </div>
  )
}

export default VerifyEmail
